import { render, staticRenderFns } from "./block.vue?vue&type=template&id=faa40c48&"
import script from "./block.vue?vue&type=script&lang=js&"
export * from "./block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faa40c48')) {
      api.createRecord('faa40c48', component.options)
    } else {
      api.reload('faa40c48', component.options)
    }
    module.hot.accept("./block.vue?vue&type=template&id=faa40c48&", function () {
      api.rerender('faa40c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/picker/block.vue"
export default component.exports